<template>
  <div v-html="value" />
</template>

<script lang="ts" setup>
  export interface Props {
    value: string;
  }

  defineProps<Props>();
</script>
